var _ChatServiceInit_scrollLock, _ChatServiceInit_scrollDownEvent, _ChatServiceInit_activeChatMessage;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
class ChatServiceInit {
    constructor() {
        _ChatServiceInit_scrollLock.set(this, writable(false));
        _ChatServiceInit_scrollDownEvent.set(this, writable(null));
        _ChatServiceInit_activeChatMessage.set(this, writable(null));
    }
    get scrollLock() {
        return __classPrivateFieldGet(this, _ChatServiceInit_scrollLock, "f");
    }
    get activeChatMessage() {
        return __classPrivateFieldGet(this, _ChatServiceInit_activeChatMessage, "f");
    }
    get scrollDownEvent() {
        return __classPrivateFieldGet(this, _ChatServiceInit_scrollDownEvent, "f");
    }
    requestScrollDown(force = false) {
        __classPrivateFieldGet(this, _ChatServiceInit_scrollDownEvent, "f").set({ force });
    }
    setActive(chatMessageHash) {
        __classPrivateFieldGet(this, _ChatServiceInit_activeChatMessage, "f").set(chatMessageHash);
    }
    setScrollLock(value) {
        __classPrivateFieldGet(this, _ChatServiceInit_scrollLock, "f").set(value);
    }
}
_ChatServiceInit_scrollLock = new WeakMap(), _ChatServiceInit_scrollDownEvent = new WeakMap(), _ChatServiceInit_activeChatMessage = new WeakMap();
export const ChatService = new ChatServiceInit();
